export const LOCATIONS = { //khai báo các đường dẫn chuyển hướng trang
    LAYOUT: '/',
    HOME: '/home',
    REGISTER: '/register',
}